import { Button, Card, CardButtonActionMode, HeaderGradient, MiniCard, Row } from '@app/components';
import React, { Fragment, memo } from 'react';
import SvgInfo from '@app/components/icons/SvgInfo';
import { SlantTitle } from '@app/components/typography';
import { theme } from '@app/theme';
import { useDynamicSizes } from '@app/hooks';
import LinearGradient from 'react-native-linear-gradient';
import { StyleSheet, View } from 'react-native';
import { IOrganization, isOrganizationWithHubrise } from '@tickeat/types';
import { UseFormReturn } from 'react-hook-form';
import { CheckPermissions } from '@app/components/CheckPermissions';

type OrganizationCardProps = {
  organization?: Partial<IOrganization>;
  formMethods: UseFormReturn<any, any, any>;
  onConnectHubrise: () => void;
  onDisconnectHubrise: () => void;
};

export const OrganizationCard = memo(({ organization, onConnectHubrise, onDisconnectHubrise }: OrganizationCardProps) => {
  const { subContainerHeight } = useDynamicSizes();

  return (
    <Card>

      <HeaderGradient>
        <LinearGradient
          start={{ x: 0.5, y: 0 }}
          end={{ x: 0.5, y: 1 }}
          locations={[0, 1]}
          colors={['rgba(253, 255, 252, 0)', 'rgba(253, 255, 252, 1)']}
          style={styles.headerGradient}
        />
      </HeaderGradient>

      <Card.TopHeader>
        <Card.TopHeaderLabel>Fiche organisation</Card.TopHeaderLabel>
      </Card.TopHeader>

      <Card.Container height={subContainerHeight}>
        <Card.Background source={require('@app/assets/img/cardbackground.png')} />

        <Card.Content>
          <Card.Header>
            <Row justify="space-between" align="center">
              <Card.HeaderTitles>
                <Card.Title numberOfLines={2}>{organization?.name}</Card.Title>
                {organization?._id && <Card.Subtitle>Ref: {organization.token}</Card.Subtitle>}
              </Card.HeaderTitles>
            </Row>
          </Card.Header>
        </Card.Content>

        <MiniCard>
          <MiniCard.Tabs>
            <MiniCard.TabsHolder>
              <MiniCard.Tab Icon={SvgInfo} isActive />
            </MiniCard.TabsHolder>
          </MiniCard.Tabs>

          <MiniCard.Container>
            <MiniCard.Content>
              <CheckPermissions permissions={['dashboard::organizations.hubrise-connect']}>

                <Card.LineBreak height={16} />

                <SlantTitle label="Informations Hubrise" color={theme.colors.gold} />

                <MiniCard.Description>
                  {(!!organization && isOrganizationWithHubrise(organization)) && (
                    <View style={{ display: 'flex', gap: 5, flexDirection: 'column' }}>
                      <Button
                        title="Voir sur Hubrise"
                        onPress={() => window.open(`https://manager.hubrise.com/dashboard?account_id=${organization?.externalApiConfig?.hubrise?.accountId}`, '_blank')} />

                      {/*
                    <Button
                      title="Déconnecter"
                      bordered
                      important
                      onPress={() => onDisconnectHubrise()} /> */}
                    </View>
                  )}

                  {(!!organization && !isOrganizationWithHubrise(organization)) && (
                    <Button
                      title="Se connecter à Hubrise"
                      onPress={() => onConnectHubrise()} />
                  )}
                </MiniCard.Description>
              </CheckPermissions>

              <Card.LineBreak height={500} />

            </MiniCard.Content>
          </MiniCard.Container>

        </MiniCard>
      </Card.Container>
    </Card>
  );
});

const styles = StyleSheet.create({
  headerGradient: {
    flex: 1,
    height: theme.sizes.listHeaderHeight,
  },
});
